export default "__VITE_ASSET__Cjo4sDg$__"